// extracted by mini-css-extract-plugin
export default {"container":"Kaa-z","productName":"Laa-z","price":"Maa-z","dimensions":"Naa-z"};